import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import './form.css';


const OtpScreen = ({ handleOtpSubmit }) => {
  const { t } = useTranslation();

  const [otp, setOtp] = useState('');

  const handleChange = (e) => {
    setOtp(e.target.value);
  };

  const onSubmit = () => {
    handleOtpSubmit(otp);
  };

  return (
    <form className="form">
      <h3>{t("register_otp.enter_otp")}</h3>
      <div className="form-row">
        <label htmlFor="otp" className="form-label">
        {t("register_otp.otp")}
        </label>
        <input
          type="text"
          id="otp"
          name="otp"
          value={otp}
          onChange={handleChange}
          className="form-input"
        />
      </div>
      <button type="button" className="btn btn-block" onClick={onSubmit}>
      {t("register_otp.submit_otp")}
      </button>
    </form>
  );
};

export default OtpScreen;
